<!-- original reference -->
<!-- glitch: https://codepen.io/acupoftee/pen/WNbBxXq -->
<!-- firework: https://codepen.io/chriscourses/pen/KqRoLw -->

<script setup lang="ts">
import { hexToRGB } from '~/utils/color'

const developers = [
  {
    name: 'song jaeyoung',
    role: 'product owner & backend developer',
  },
  {
    name: 'song byeongwoo',
    role: 'product manager & planning',
  },
  {
    name: 'pjw',
    role: 'frontend developer',
  },
  {
    name: 'lee haejun',
    role: 'frontend developer',
  },
  {
    name: 'jo wonik',
    role: 'backend developer',
  },
  {
    name: 'lee dabeen',
    role: 'backend developer',
  },
  {
    name: 'yoon gyeonghan',
    role: 'backend developer',
  },
  {
    name: 'seo hyeonjun',
    role: 'backend developer',
  },
  {
    name: 'kim jinwoo',
    role: 'product designer',
  },
  {
    name: 'kim jinseon',
    role: 'devops engineer',
  },
  {
    name: 'lee hyewon',
    role: 'frontend developer',
  },
]

const pointColor = '#7e3af2'

const index = ref()

const getRandomIndex = () => {
  let randomIndex
  do {
    randomIndex = Math.floor(Math.random() * (developers.length))
  } while (randomIndex === index.value)
  return randomIndex
}

index.value = getRandomIndex()

const canvasRef = ref()

// firework method
const firework = async () => {
  await nextTick()
  const canvas = canvasRef.value
  if (!window || !canvas) {
    return
  }
  const c = canvas.getContext('2d')

  canvas.width = window.innerWidth
  canvas.height = window.innerHeight

  // Event Listeners
  addEventListener('resize', function () {
    canvas.width = window.innerWidth
    canvas.height = window.innerHeight

    init()
  })

  // Utility Functions
  function randomIntFromRange (min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min)
  }

  // Objects
  function Particle (x, y, dx, dy, radius, color) {
    this.x = x
    this.y = y
    this.dx = dx
    this.dy = -dy
    this.radius = 5
    this.color = color
    this.timeToLive = 2
    this.opacity = 1
    this.r = 10
    this.g = 10
    this.b = 10

    this.update = function () {
      if (this.y + this.radius + this.dy > canvas.height) {
        this.dy = -this.dy
      }

      if (this.x + this.radius + this.dx > canvas.width || this.x - this.radius + this.dx < 0) {
        this.dx = -this.dx
      }
      // this.dy += gravity * this.mass;
      this.x += Math.random() > 0.5 ? dx : -dx
      this.y += Math.random() > 0.5 ? dy : -dy
      this.draw()

      this.timeToLive -= 0.01
    }

    this.draw = function () {
      this.opacity = this.timeToLive / 1

      c.save()
      c.beginPath()
      c.arc(this.x, this.y, 2, 0, Math.PI * 2, false)
      c.fillStyle = hexToRGB(pointColor, this.opacity.toFixed(2))
      // c.fillStyle = 'rgba(' + this.r + ',' + this.g + ',' + this.b + ',' + this.opacity.toFixed(2) + ')'
      c.fill()

      c.closePath()

      c.restore()
    }
  }

  function Mortar (x, y, dx, dy, radius, color) {
    this.x = x
    this.y = y
    this.dx = dx
    this.dy = dy
    this.radius = radius
    this.color = color
    this.triggered = false
    this.explosion
    this.waveOffset = randomIntFromRange(1, 2)

    this.update = delta => {
      this.draw()
      this.ttl -= 1

      this.dy += 0.11
      this.x += this.dx * Math.sin(delta) * this.waveOffset
      this.y += this.dy

      if (this.dy > 0) {
        this.triggered = true
      }
    }

    this.draw = function () {
      c.beginPath()
      c.arc(this.x, this.y, this.radius, 0, Math.PI * 2, false)
      c.fillStyle = this.color
      c.fill()
      c.closePath()
    }

    this.explode = function (callback) {
      // Create explosion... if particle count == 0, call callback
      if (typeof this.explosion == 'undefined') {
        this.explosion = new Explosion(this)
        this.radius = 0
      }
      this.explosion.update()

      if (this.explosion.particles.length <= 0) {
        callback()
      }
    }
  }

  function Explosion (source) {
    this.particles = []
    this.rings = []
    this.source = source

    this.init = function () {
      for (let i = 0; i < 12; i++) {
        const v = 7
        const dx = v
        const dy = v

        // var hue = (255 / 5) * i;
        // var color = "hsl(" + hue + ", 100%, 50%)";
        this.particles.push(new Particle(this.source.x, this.source.y, dx, dy, 1, pointColor))
      }
    }

    this.init()

    this.update = function () {
      for (let i = 0; i < this.particles.length; i++) {
        this.particles[i].update()

        // Remove particles from scene one time to live is up
        if (this.particles[i].timeToLive < 0) {
          this.particles.splice(i, 1)
        }
      }
    }
  }

  // Implementation
  const mortars = []

  function init () {
  }

  // Animation Loop
  let elapsed = 0
  let randomInterval = randomIntFromRange(80, 170)

  function animate () {
    requestAnimationFrame(animate)
    c.fillStyle = 'rgba(0, 0, 0, 0.05)'
    c.fillRect(0, 0, canvas.width, canvas.height)

    for (let i = 0; i < mortars.length; i++) {
      mortars[i].update(elapsed)

      if (mortars[i].triggered === true) {
        mortars[i].explode(() => {
          mortars.splice(i, 1)
        })
      }
    }

    if (elapsed % randomInterval == 0) {
      const x = randomIntFromRange(10, canvas.width - 10)
      const dy = randomIntFromRange(-5, -10)
      mortars.push(new Mortar(x, canvas.height, 2, dy, 3, pointColor))
      randomInterval = randomIntFromRange(50, 100)
    }

    elapsed += 1
  }

  init()
  animate()
}

let intervalId: NodeJS.Timeout
watchEffect(() => {
  if (showCredit.value) {
    intervalId = setInterval(() => {
      index.value = getRandomIndex()
    }, 4000)
  } else {
    clearInterval(intervalId)
  }
})

onMounted(async () => {
  await firework()
})

onUpdated(async () => {
  await firework()
})

onBeforeUnmount(() => {
  clearInterval(intervalId)
})

const changeShowCredit = () => {
  showCredit.value = false
}
</script>

<template>
  <Teleport to="body">
    <div
      v-if="showCredit"
      class="background"
      @click="changeShowCredit"
    >
      <canvas
        ref="canvasRef"
        class="fixed bottom-[-100px]"
      />
      <div class="container">
        <p class="subtitle made-by">
          made by
        </p>
        <div
          class="glitch"
          :data-text="developers[index].name"
        >
          {{ developers[index].name }}
        </div>
        <div class="glow" />
        <p class="subtitle">
          {{ developers[index].role }}
        </p>
      </div>
      <div class="scanlines" />
      <p class="subtitle close">
        click to close
      </p>
    </div>
  </Teleport>
</template>

<style scoped lang="scss">
.background {
  @apply bg-background fixed top-0 left-0 w-full h-full z-[1000] italic font-bold overflow-hidden uppercase;
}

.container {
  margin: 0 auto;
  position: relative;
  padding: 25vh .5rem 0;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.glitch {
  color: rgb(223, 191, 191);
  position: relative;
  font-size: 8vw;
  animation: glitch 4s 4s infinite;
  width: 100%;
  white-space: nowrap;

  @include sm {
    font-size: 10vw;
    white-space: normal;
    word-spacing: 100vw;
    line-height: 1;
    margin-bottom: 1rem;
  }
}

.glitch::before {
  @apply bg-background;
  content: attr(data-text);
  position: absolute;
  left: -2px;
  text-shadow: -5px 0 magenta;
  overflow: hidden;
  top: 0;
  animation: noise-1 3s linear infinite alternate-reverse, glitch 4s 4.05s infinite;
  width: 100%;
  white-space: nowrap;

  @include sm {
    white-space: normal;
    word-spacing: 100vw;
    line-height: 1;
  }
}

.glitch::after {
  @apply bg-background;
  content: attr(data-text);
  position: absolute;
  left: 2px;
  text-shadow: -5px 0 lightgreen;
  overflow: hidden;
  top: 0;
  animation: noise-2 3s linear infinite alternate-reverse, glitch 4s 4s infinite;
  width: 100%;
  white-space: nowrap;

  @include sm {
    white-space: normal;
    word-spacing: 100vw;
    line-height: 1;
  }
}

@keyframes glitch {
  1% {
    transform: rotateX(10deg) skewX(90deg);
  }
  2% {
    transform: rotateX(0deg) skewX(0deg);
  }
}

@keyframes noise-1 {
  $steps: 30;
  @for $i from 1 through $steps {
    #{percentage($i*(1/$steps))} {
      $top: random(100);
      $bottom: random(101 - $top);
      clip-path: inset(#{$top}px 0 #{$bottom}px 0);
    }
  }
}

@keyframes noise-2 {
  $steps: 30;
  @for $i from 0 through $steps {
    #{percentage($i*(1/$steps))} {
      $top: random(100);
      $bottom: random(101 - $top);
      clip-path: inset(#{$top}px 0 #{$bottom}px 0);
    }
  }
}

.scanlines {
  overflow: hidden;
  mix-blend-mode: difference;
}

.scanlines::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;

  background: repeating-linear-gradient(
      to bottom,
      transparent 0%,
      rgba(255, 255, 255, 0.05) .5%,
      transparent 1%
  );

  animation: fudge 6s ease-in-out alternate infinite;
}

@keyframes fudge {
  from {
    transform: translate(0px, 0px);
  }
  to {
    transform: translate(0px, 2%);
  }
}

.glow {
  @extend .glitch;
  text-shadow: 0 0 1000px rgb(223, 191, 191);
  color: transparent;
  position: absolute;
  top: 0;
}

.subtitle {
  @apply text-primary/40;
  font-family: Arial, Helvetica, sans-serif;
  font-weight: 100;
  font-size: 1.2vw;
  letter-spacing: 1em;
  text-align: center;
  animation: glitch-2 4s 4.02s infinite;

  &.made-by {
    @apply text-xl mb-16 tracking-[1.5vw] ml-4;
  }

  &.close {
    @apply text-primary/40 font-bold;
    text-shadow: black 2px 2px, black -2px -2px, black 2px -2px, black -2px 2px;
    font-size: 1.5vw;
    position: absolute;
    bottom: 4rem;
    width: 100%;
    letter-spacing: .4rem;
  }
}

@keyframes glitch-2 {
  1% {
    transform: rotateX(10deg) skewX(70deg);
  }
  2% {
    transform: rotateX(0deg) skewX(0deg);
  }
}

</style>
